import React from 'react';
import { connect } from 'react-redux';
import UserRestoreDialog from './UserRestoreDialog';
import UsersAutoApprovalDialog from './UsersAutoApprovalDialog';
import UserArchivalDialog from './UserArchivalDialog';

const UserDialogs = ({
  allowApproval,
  allowArchive,
  allowRestore,
  theme,
}) => (
  <>
    {allowApproval && (<UsersAutoApprovalDialog theme={theme} />)}
    {allowArchive && (<UserArchivalDialog theme={theme} />)}
    {allowRestore && (<UserRestoreDialog theme={theme} />)}
  </>
);

const mapStateToProps = ({
  auth: { archiveUsers, role: { permissions: { configurations: { update }, users: { destroy } } } },
  configurations: { activeApprovalOpen },
}) => ({
  allowApproval: activeApprovalOpen && update,
  allowArchive: archiveUsers.open && destroy,
  allowRestore: archiveUsers.restoreOpen && destroy,
});

export default connect(mapStateToProps)(UserDialogs);
